// removed by extract-text-webpack-plugin
module.exports = {"white":"src-components-modules-Hero-HeroSkinny-style----background-module---white---29TYH bg-white","black":"src-components-modules-Hero-HeroSkinny-style----background-module---black---1SztW bg-licorice"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Hero/HeroSkinny/style/background.module.css
// module id = 1475
// module chunks = 168707334958949